import { support } from '../../content/support.js';
import { Icon } from '../Icon/Icon.js';

export function SupportCard() {
  return (
    <section
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(16px,2.4vw,22px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%,280px), 1fr))',
          gap: '15px',
        }}
      >
        <div
          style={{
            borderRadius: '26px',
            padding: 'clamp(24px,3vw,34px)',
            background: 'var(--glass)',
            border: '1px solid var(--edge)',
            backdropFilter: 'blur(var(--blur))',
            WebkitBackdropFilter: 'blur(var(--blur))',
            boxShadow: 'var(--cardShadow)',
          }}
        >
          <div
            style={{
              width: '46px',
              height: '46px',
              borderRadius: '14px',
              background: 'var(--yellow)',
              display: 'grid',
              placeItems: 'center',
              boxShadow: 'var(--glowSm)',
            }}
          >
            <Icon name="chat" style={{ fontSize: '25px', color: '#0B1B2B' }} />
          </div>
          <h3
            style={{
              margin: '19px 0 0',
              font: "800 21px/1.15 'Plus Jakarta Sans',sans-serif",
              letterSpacing: '-.022em',
              color: 'var(--ink)',
            }}
          >
            Need a hand?
          </h3>
          <p
            style={{
              margin: '10px 0 0',
              font: "500 14px/1.55 'Plus Jakarta Sans',sans-serif",
              color: 'var(--muted)',
              textWrap: 'pretty',
            }}
          >
            {support.support.description}
          </p>
          <div
            style={{
              marginTop: '17px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              font: "600 14px/1.4 'Plus Jakarta Sans',sans-serif",
            }}
          >
            {support.support.channels.map((channel) => (
              <a
                key={channel.href}
                href={channel.href}
                {...(channel.newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                {channel.label}
              </a>
            ))}
          </div>
          {support.placeholder && (
            <div
              style={{
                marginTop: '13px',
                font: "500 12px/1.4 'Plus Jakarta Sans',sans-serif",
                color: 'var(--faint)',
              }}
            >
              Placeholder contacts.
            </div>
          )}
        </div>
        <div
          style={{
            borderRadius: '26px',
            padding: 'clamp(24px,3vw,34px)',
            background: 'var(--glass)',
            border: '1px solid var(--edge)',
            backdropFilter: 'blur(var(--blur))',
            WebkitBackdropFilter: 'blur(var(--blur))',
            boxShadow: 'var(--cardShadow)',
          }}
        >
          <div
            style={{
              width: '46px',
              height: '46px',
              borderRadius: '14px',
              background: 'var(--blue)',
              display: 'grid',
              placeItems: 'center',
              boxShadow: 'var(--glowBlue)',
            }}
          >
            <Icon name="mail" style={{ fontSize: '25px', color: '#FFFFFF' }} />
          </div>
          <h3
            style={{
              margin: '19px 0 0',
              font: "800 21px/1.15 'Plus Jakarta Sans',sans-serif",
              letterSpacing: '-.022em',
              color: 'var(--ink)',
            }}
          >
            Work with us
          </h3>
          <p
            style={{
              margin: '10px 0 0',
              font: "500 14px/1.55 'Plus Jakarta Sans',sans-serif",
              color: 'var(--muted)',
              textWrap: 'pretty',
            }}
          >
            {support.careers.description}
          </p>
          <div style={{ marginTop: '17px', font: "600 14px/1.4 'Plus Jakarta Sans',sans-serif" }}>
            {support.careers.channels.map((channel) => (
              <a key={channel.href} href={channel.href}>
                {channel.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
